module.exports = __webpack_public_path__ + "img/im_scrollfeature_17@2x.812c7181.jpg";